import { SpeechesData } from './SpeechesData';
import { YearsData } from './YearsData';

export * from './SpeechData';
export * from './SpeechesData';

const speeches = new SpeechesData();
const years = new YearsData(speeches);

export default {
    speeches,
    years,
};
